import React from 'react';
import { DropdownItem } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import IntlMessages from 'util/IntlMessages';
import ListRowImage from 'components/listRowImage';
import ListRowFavourite from 'components/ListRowFavourite';
import ListRowCheckbox from 'components/ListRowCheckbox';
import ListRowData from 'components/ListRowData';
import ListRowDropdown from 'components/ListRowDropdown';
import SecurityAdd from '../../securityAdd/index';

class SecurityRow extends React.Component {
    constructor() {
        super();
        this.state = {
            menuState: false,
            addSecurityState: false,
            deleteSecurityCheck: false,
        };
    }

    onSecurityOptionToggle = () => {
        this.setState({ menuState: !this.state.menuState });
    };
    onSecurityClose = () => {
        this.setState({ addSecurityState: false });
    };
    onDeleteSecurity = (security) => {
        this.setState({ addSecurityState: false });
        this.props.onDeleteSecurity(security ?.id);
    };
    onEditSecurity = () => {
        this.setState({ menuState: false, addSecurityState: true });
    };

    render() {
        const { width, security, addFavouriteSecurity, onSecuritySelect, onSaveSecurity, showSecurityLoader } = this.props;
        const { menuState, addSecurityState, deleteSecurityCheck } = this.state;
        const { name, key, account, starred } = security;
        const options = [
            'Edit',
            'Delete',
        ];
        const maskKey = '********'.concat(key.substring(key.length - 4, key.length));
        return (
            <div className="contact-item">
                <ListRowCheckbox selected={security.selected} onClick={() => { onSecuritySelect(security); }} />
                <ListRowFavourite width={width} onClick={() => { addFavouriteSecurity(security); }} starred={starred} />
                <ListRowImage width={width} data={security} />
                <ListRowData lineOne={name} lineTwoLeft={maskKey} lineTwoRight={account} />
                <ListRowDropdown
                    menuState={menuState}
                    toggle={this.onSecurityOptionToggle.bind(this)}
                    options={options}
                    dropdownItems={options.map(option =>
                        <DropdownItem key={option} onClick={() => {
                            if (option === 'Edit') {
                                this.onEditSecurity();
                            } else if (option === 'Delete') {
                                this.setState({ deleteSecurityCheck: true });
                            }
                        }
                        }>
                            {option}
                        </DropdownItem>,
                    )}
                />
                <div>
                    {addSecurityState &&
                        <SecurityAdd
                            open={addSecurityState}
                            security={security}
                            onSaveSecurity={onSaveSecurity}
                            onSecurityClose={this.onSecurityClose}
                            onDeleteSecurity={this.onDeleteSecurity}
                            showSecurityLoader={showSecurityLoader}
                        />
                    }
                </div>
                <SweetAlert show={deleteSecurityCheck}
                    warning
                    showCancel
                    confirmBtnText={<IntlMessages id="button.yesDeleteIt" />}
                    cancelBtnText={<IntlMessages id="button.cancel" />}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title={<span style={{ fontWeight: 'bold', color: 'grey', fontSize: '200%' }}><IntlMessages id="general.areYouSure" /></span>}
                    onConfirm={() => {
                        this.onDeleteSecurity(security);
                        this.setState({ deleteSecurityCheck: false });
                    }}
                    onCancel={() => {
                        this.setState({ deleteSecurityCheck: false });
                    }}
                >
                    <IntlMessages id="security.deleteSecurity" />
                </SweetAlert>
            </div>
        );
    }
}

export default SecurityRow;


// WEBPACK FOOTER //
// ./components/Agile/security/securityList/securityRow/index.js